import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@env/environment';
@Pipe({ name: 'size' })
export class SizePipe implements PipeTransform {
    transform(value: string, size: 's' | 'm' | 'l'): string {
        const sizes = environment.imageResolutions;

        switch (size) {
            case 's':
                return value + `?x=${sizes.s}`;
            case 'm':
                return value + `?x=${sizes.m}`;
            case 'l':
                return value + `?x=${sizes.l}`;
        }
    }
}
